<script setup lang="ts">
defineProps<{
  message?: string
  title?: string
}>()
</script>

<template>
  <UCard
    class="font-poppins flex h-screen flex-col p-10 text-[16px] sm:h-[540px] sm:rounded-xl sm:shadow-xl"
  >
    <template #header>
      <header :class="{ 'pb-5': message }">
        <RialticLogo class="h-10" />
        <h1
          class="mt-6 mb-4 text-[24px] leading-9 font-semibold tracking-normal text-neutral-900"
        >
          {{ title || 'Welcome' }}
        </h1>
        <p v-if="message" class="text-sm leading-[21px] text-neutral-700">
          {{ message }}
        </p>
      </header>
    </template>
    <slot />
  </UCard>
</template>
